import React from 'react'
//import EventInvite from './EventInvite'
export default class EventInvite extends React.Component {
  render () {
    return (<DatePicker
    selected={this.state.startDate}
    onChange={this.handleChange}
    popoverAttachment="bottom center"
    popoverTargetAttachment="top center"
    popoverTargetOffset="0px 0px"
/>
)
  }
}




// WEBPACK FOOTER //
// ./src/components/EventInvite.js